import React from 'react';
import Select from 'react-select';
import ModalCadastro from 'components/_base/modal-cadastro';

export default function ModalTrocaEquipe({
  showModal,
  setShowModal,
  onClose,
  usuario,
  updateRepresentante,
  equipes
}) {
  const [editaUsuario, setEditaUsuario] = React.useState(usuario);

  return (
    <ModalCadastro
      showModal={showModal}
      setShowModal={setShowModal}
      headerText={`TROCA DE EQUIPES`}
      onClose={onClose}
    >
      <div className="modal-body">
        <div className="mb-3">
          <label>Equipe</label>
          <Select
            isClearable={false}
            options={equipes}
            placeholder="Equipe"
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.equipeId}
            value={equipes?.find((p) => p.equipeId === usuario?.equipeId)}
            onChange={(p) => {
              setEditaUsuario({
                ...usuario,
                equipeId: p.equipeId,
                usuarioSuperiorId: p.usuarioSupervisorId
              });
              usuario.equipeId = p.equipeId;
              usuario.usuarioSuperiorId = p.usuarioSupervisorId;
            }}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            updateRepresentante(editaUsuario);
            setShowModal(false);
          }}
        >
          SALVAR
        </button>
      </div>
    </ModalCadastro>
  );
}
